// Cloned from @wandb/ui 0.1.0 as part of removing the @wandb/ui dependency.
// One intentional difference: the original also injected @font-face rules
// (GlobalFontStyles); those fonts are already provided globally by
// common/css/Base.less, so they are omitted here.
import {ThemeProvider as MUThemeProvider} from '@mui/material/styles';
import React, {useMemo} from 'react';
import {
  type DefaultTheme,
  ThemeProvider as StyledThemeProvider,
} from 'styled-components';

import {foundations} from './foundation';
import {LightTheme} from './material-ui/light-theme/light-theme';
import {Theme} from './types';

const themeMap = {
  light: LightTheme,
};

/**
 * Uses React context to inject a theme for your W&B app.
 */
export const ThemeProvider: React.FC<{
  theme?: keyof typeof themeMap;
  children?: React.ReactNode;
}> = ({theme, children}) => {
  const muTheme = useMemo(
    () => (theme == null ? LightTheme : themeMap[theme]),
    [theme]
  );
  const styleTheme = useMemo<Theme>(
    () => ({...foundations, ...muTheme}),
    [muTheme]
  );

  return (
    <MUThemeProvider theme={muTheme}>
      <StyledThemeProvider theme={styleTheme as unknown as DefaultTheme}>
        {children}
      </StyledThemeProvider>
    </MUThemeProvider>
  );
};
